import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const Privacy = () => {
  return (
    <div className="w-full min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow flex-col flex items-center justify-center">
        <div className="w-[70%] mx-auto p-6 bg-white my-24">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Website Privacy Policy
          </h1>
          <p className="text-sm text-gray-600 italic mb-6">
            Last modified: February 15, 2025
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Introduction
            </h2>
            <p className="text-gray-700 mb-4">
              Globelink Techservices (OPC) Private Limited ("Company" or "We")
              respect your privacy and are committed to protecting it through
              our compliance with this policy.
            </p>
            <p className="text-gray-700 mb-4">
              This policy describes the types of information we may collect from
              you or that you may provide when you visit the website{" "}
              <a
                href="http://www.globelinkplacement.com"
                className="text-blue-600 hover:underline"
              >
                www.globelinkplacement.com
              </a>{" "}
              (our "Website") and our practices for collecting, using,
              maintaining, protecting, and disclosing that information.
            </p>
            <p className="text-gray-700 mb-4">
              This policy applies to information we collect:
              <ul className="list-disc pl-5">
                <li>On this Website.</li>
                <li>
                  In email, text, and other electronic messages between you and
                  this Website.
                </li>
                <li>
                  Through mobile and desktop applications you download from this
                  Website, which provide dedicated non-browser-based interaction
                  between you and this Website.
                </li>
                <li>
                  When you interact with our advertising and applications on
                  third-party websites and services, if those applications or
                  advertising include links to this policy.
                </li>
                <li>Any other sources with your consent.</li>
              </ul>
            </p>
            <p className="text-gray-700">
              It does not apply to information collected by:
              <ul className="list-disc pl-5">
                <li>
                  Us offline or through any other means, including on any other
                  website operated by Company or any third party (including our
                  affiliates and subsidiaries); or
                </li>
                <li>
                  Any third party (including our affiliates and subsidiaries),
                  including through any application or content (including
                  advertising) that may link to or be accessible from or on the
                  Website.
                </li>
              </ul>
            </p>
            <p className="text-gray-700 mt-4">
              Please read this policy carefully to understand our policies and
              practices regarding your information and how we will treat it. If
              you do not agree with our policies and practices, your choice is
              not to use our Website. By accessing or using this Website, you
              agree to this privacy policy. This policy may change from time to
              time. Your continued use of this Website after we make changes is
              deemed to be acceptance of those changes, so please check the
              policy periodically for updates.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Anyone Under the Age of 18
            </h2>
            <p className="text-gray-700">
              Our Website is not intended for anyone under 18 years of age. No
              one under age 18 may provide any personal information to or on the
              Website. We do not knowingly collect personal information from
              anyone under 18. If you are under 18, do not use or provide any
              information on this Website or through any of its features,
              register on the Website, make any purchases through the Website,
              use any of the interactive or public comment features of this
              Website, or provide any information about yourself to us,
              including your name, address, telephone number, email address, or
              any screen name or user name you may use. If we learn we have
              collected or received personal information from anyone under 18
              without verification of parental consent, we will delete that
              information. If you believe we might have any information from or
              about a child under 18, please contact us at{" "}
              <a
                href="mailto:Info@globelinkplacement.com"
                className="text-blue-600 hover:underline"
              >
                Info@globelinkplacement.com
              </a>
              .
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Information We Collect About You and How We Collect It
            </h2>
            <p className="text-gray-700 mb-4">
              We collect several types of information from and about users of
              our Website, including information:
              <ul className="list-disc pl-5">
                <li>
                  By which you may be personally identified, such as name,
                  postal address, e-mail address, telephone number, social
                  security number or other personal information collected/any
                  other identifier by which you may be contacted online or
                  offline ("personal information");
                </li>
                <li>
                  That is about you but individually does not identify you, such
                  as; and/or
                </li>
                <li>
                  About your internet connection, the equipment you use to
                  access our Website, and usage details.
                </li>
              </ul>
            </p>
            <p className="text-gray-700">
              We collect this information:
              <ul className="list-disc pl-5">
                <li>Directly from you when you provide it to us.</li>
                <li>
                  Automatically as you navigate through the site. Information
                  collected automatically may include usage details, IP
                  addresses, and information collected through cookies, web
                  beacons, and other tracking technologies.
                </li>
                <li>From third parties, for example, our business partners.</li>
              </ul>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Information You Provide to Us
            </h2>
            <p className="text-gray-700 mb-4">
              The information we collect on or through our Website may include:
              <ul className="list-disc pl-5">
                <li>
                  Information that you provide by filling in forms on our
                  Website. This includes information provided at the time of
                  registering to use our Website, subscribing to our service,
                  posting material, or requesting further services. We may also
                  ask you for information when you enter a contest or promotion
                  sponsored by us, and when you report a problem with our
                  Website.
                </li>
                <li>
                  Records and copies of your correspondence (including email
                  addresses) if you contact us.
                </li>
                <li>
                  Your responses to surveys that we might ask you to complete
                  for research purposes.
                </li>
                <li>
                  Details of transactions you carry out through our Website and
                  of the fulfillment of your orders. You may be required to
                  provide financial information before placing an order through
                  our Website.
                </li>
                <li>Your search queries on the Website.</li>
                <li>Any other types of information that you provide.</li>
              </ul>
            </p>
            <p className="text-gray-700">
              You also may provide information to be published or displayed
              (hereinafter, "posted") on public areas of the Website, or
              transmitted to other users of the Website or third parties
              (collectively, "User Contributions"). Your User Contributions are
              posted on and transmitted to others at your own risk. Although we
              limit access to certain pages, please be aware that no security
              measures are perfect or impenetrable. Additionally, we cannot
              control the actions of other users of the Website with whom you
              may choose to share your User Contributions. Therefore, we cannot
              and do not guarantee that your User Contributions will not be
              viewed by unauthorized persons.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Information We Collect Through Automatic Data Collection
              Technologies
            </h2>
            <p className="text-gray-700 mb-4">
              As you navigate through and interact with our Website, we may use
              automatic data collection technologies to collect certain
              information about your equipment, browsing actions, and patterns,
              including:
              <ul className="list-disc pl-5">
                <li>
                  Details of your visits to our Website, including traffic data,
                  location data, logs, and other communication data and the
                  resources that you access and use on the Website.
                </li>
                <li>
                  Information about your computer and internet connection,
                  including your IP address, operating system, and browser type.
                </li>
              </ul>
            </p>
            <p className="text-gray-700 mb-4">
              We also may use these technologies to collect information about
              your online activities over time and across third-party websites
              or other online services (behavioral tracking). Send us an email
              at{" "}
              <a
                href="mailto:Info@globelinkplacement.com"
                className="text-blue-600 hover:underline"
              >
                Info@globelinkplacement.com
              </a>{" "}
              to opt out of behavioral tracking on this website and how we
              respond to web browser signals and other mechanisms that enable
              consumers to exercise choice about behavioral tracking.
            </p>
            <p className="text-gray-700 mb-4">
              The information we collect automatically may include personal
              information, or we may maintain it or associate it with personal
              information we collect in other ways or receive from third
              parties. It helps us to improve our Website and to deliver a
              better and more personalized service, including by enabling us to:
              <ul className="list-disc pl-5">
                <li>Estimate our audience size and usage patterns.</li>
                <li>
                  Store information about your preferences, allowing us to
                  customize our Website according to your individual interests.
                </li>
                <li>Speed up your searches.</li>
                <li>Recognize you when you return to our Website.</li>
              </ul>
            </p>
            <p className="text-gray-700">
              The technologies we use for this automatic data collection may
              include:
              <ul className="list-disc pl-5">
                <li>
                  <span className="font-medium text-[#75000e]">
                    Cookies (or browser cookies).
                  </span>{" "}
                  A cookie is a small file placed on the hard drive of your
                  computer. You may refuse to accept browser cookies by
                  activating the appropriate setting on your browser. However,
                  if you select this setting you may be unable to access certain
                  parts of our Website. Unless you have adjusted your browser
                  setting so that it will refuse cookies, our system will issue
                  cookies when you direct your browser to our Website.
                </li>
                <li>
                  <span className="font-medium text-[#75000e]">
                    Flash Cookies.
                  </span>{" "}
                  Certain features of our Website may use local stored objects
                  (or Flash cookies) to collect and store information about your
                  preferences and navigation to, from, and on our Website. Flash
                  cookies are not managed by the same browser settings as are
                  used for browser cookies. For information about managing your
                  privacy and security settings for Flash cookies, see Choices
                  About How We Use and Disclose Your Information.
                </li>
                <li>
                  <span className="font-medium text-[#75000e]">
                    Web Beacons.
                  </span>{" "}
                  Pages of our the Website and our e-mails may contain small
                  electronic files known as web beacons (also referred to as
                  clear gifs, pixel tags, and single-pixel gifs) that permit the
                  Company, for example, to count users who have visited those
                  pages or opened an email and for other related website
                  statistics (for example, recording the popularity of certain
                  website content and verifying system and server integrity).
                </li>
              </ul>
            </p>
            <p className="text-gray-700 mt-4">
              We do not collect personal information automatically, but we may
              tie this information to personal information about you that we
              collect from other sources or you provide to us.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Third-Party Use of Cookies and Other Tracking Technologies
            </h2>
            <p className="text-gray-700 mb-4">
              Some content or applications, including advertisements, on the
              Website are served by third-parties, including advertisers, ad
              networks and servers, content providers, and application
              providers. These third parties may use cookies alone or in
              conjunction with web beacons or other tracking technologies to
              collect information about you when you use our website. The
              information they collect may be associated with your personal
              information or they may collect information, including personal
              information, about your online activities over time and across
              different websites and other online services. They may use this
              information to provide you with interest-based (behavioral)
              advertising or other targeted content.
            </p>
            <p className="text-gray-700">
              We do not control these third parties' tracking technologies or
              how they may be used. If you have any questions about an
              advertisement or other targeted content, you should contact the
              responsible provider directly. For information about how you can
              opt out of receiving targeted advertising from many providers, see
              Choices About How We Use and Disclose Your Information.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              How We Use Your Information
            </h2>
            <p className="text-gray-700 mb-4">
              We use information that we collect about you or that you provide
              to us, including any personal information:
              <ul className="list-disc pl-5">
                <li>To present our Website and its contents to you.</li>
                <li>
                  To provide you with information, products, or services that
                  you request from us.
                </li>
                <li>To fulfill any other purpose for which you provide it.</li>
                <li>
                  To provide you with notices about your account/subscription,
                  including expiration and renewal notices.
                </li>
                <li>
                  To carry out our obligations and enforce our rights arising
                  from any contracts entered into between you and us, including
                  for billing and collection.
                </li>
                <li>
                  To notify you about changes to our Website or any products or
                  services we offer or provide though it.
                </li>
                <li>
                  To allow you to participate in interactive features on our
                  Website.
                </li>
                <li>
                  In any other way we may describe when you provide the
                  information.
                </li>
                <li>For any other purpose with your consent.</li>
              </ul>
            </p>
            <p className="text-gray-700 mb-4">
              We may also use your information to contact you about our own and
              third-parties' goods and services that may be of interest to you.
              For more information, see Choices About How We Use and Disclose
              Your Information.
            </p>
            <p className="text-gray-700">
              We may use the information we have collected from you to enable us
              to display advertisements to our advertisers' target audiences.
              Even though we do not disclose your personal information for these
              purposes without your consent, if you click on or otherwise
              interact with an advertisement, the advertiser may assume that you
              meet its target criteria.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Disclosure of Your Information
            </h2>
            <p className="text-gray-700 mb-4">
              We may disclose aggregated information about our users, and
              information that does not identify any individual, without
              restriction.
            </p>
            <p className="text-gray-700 mb-4">
              We may disclose personal information that we collect or you
              provide as described in this privacy policy:
              <ul className="list-disc pl-5">
                <li>To our subsidiaries and affiliates.</li>
                <li>
                  To contractors, service providers, and other third parties we
                  use to support our business and who are bound by contractual
                  obligations to keep personal information confidential and use
                  it only for the purposes for which we disclose it to them.
                </li>
                <li>
                  Globelink may transfer certain personal information across
                  geographical borders to Globelink entities or service
                  providers in other countries working on our behalf in
                  accordance with applicable law. Globelink may transfer your
                  personal information to any other body corporate or a person
                  in any country that ensures the “same level of data
                  protection” as applicable data protection laws and
                  regulations. When you provide us with your information or use
                  our websites, we may collect, transfer, store, and process
                  your information. These transfers are governed by Indian
                  standard contractual clauses or equivalent data transfer
                  agreements to protect the security and confidentiality of
                  personal information.
                </li>
                <li>
                  To a buyer or other successor in the event of a merger,
                  divestiture, restructuring, reorganization, dissolution, or
                  other sale or transfer of some or all of Globelink’s assets,
                  whether as a going concern or as part of bankruptcy,
                  liquidation, or similar proceeding, in which personal
                  information held by Globelink Techservices Pvt. Ltd. about our
                  Website users is among the assets transferred.
                </li>
                <li>
                  To third parties to market their products or services to you
                  if you have consented to/not opted out of these disclosures.
                  We contractually require these third parties to keep personal
                  information confidential and use it only for the purposes for
                  which we disclose it to them. For more information, see
                  Choices About How We Use and Disclose Your Information.
                </li>
                <li>
                  To fulfill the purpose for which you provide it. For example,
                  if you give us an email address to use the "email a friend"
                  feature of our Website, we will transmit the contents of that
                  email and your email address to the recipients.
                </li>
                <li>
                  For any other purpose disclosed by us when you provide the
                  information.
                </li>
                <li>With your consent.</li>
              </ul>
            </p>
            <p className="text-gray-700">
              We may also disclose your personal information:
              <ul className="list-disc pl-5">
                <li>
                  To comply with any court order, law, or legal process,
                  including to respond to any government or regulatory request.
                </li>
                <li>
                  To enforce or apply our terms of use{" "}
                  <a
                    href="http://www.globelinkplacement.com/terms"
                    className="text-blue-600 hover:underline"
                  >
                    www.globelinkplacement.com/terms-of-use
                  </a>{" "}
                  or terms of sale and other agreements, including for billing
                  and collection purposes.
                </li>
                <li>
                  If we believe disclosure is necessary or appropriate to
                  protect the rights, property, or safety of Globelink
                  Techservices Pvt. Ltd., our customers, or others. This
                  includes exchanging information with other companies and
                  organizations for the purposes of fraud protection and credit
                  risk reduction.
                </li>
              </ul>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Choices About How We Use and Disclose Your Information
            </h2>
            <p className="text-gray-700 mb-4">
              We strive to provide you with choices regarding the personal
              information you provide to us. We have created mechanisms to
              provide you with the following control over your information:
              <ul className="list-disc pl-5">
                <li>
                  <span className="font-medium text-[#75000e]">
                    Tracking Technologies and Advertising.
                  </span>{" "}
                  You can set your browser to refuse all or some browser
                  cookies, or to alert you when cookies are being sent. To learn
                  how you can manage your Flash cookie settings, visit the Flash
                  player settings page on Adobe's website. If you disable or
                  refuse cookies, please note that some parts of this site may
                  then be inaccessible or not function properly.
                </li>
                <li>
                  <span className="font-medium text-[#75000e]">
                    Disclosure of Your Information for Third-Party Advertising.
                  </span>{" "}
                  If you do not want us to share your personal information with
                  unaffiliated or non-agent third parties for promotional
                  purposes, you can opt-out by sending us an email at{" "}
                  <a
                    href="mailto:Info@globelinkplacement.com"
                    className="text-blue-600 hover:underline"
                  >
                    Info@globelinkplacement.com
                  </a>
                  .
                </li>
                <li>
                  <span className="font-medium text-[#75000e]">
                    Promotional Offers from the Company.
                  </span>{" "}
                  If you do not wish to have your email address/contact
                  information used by the Company to promote our own or third
                  parties' products or services, you can opt-out at any other
                  time by sending us an email stating your request to{" "}
                  <a
                    href="mailto:Info@globelinkplacement.com"
                    className="text-blue-600 hover:underline"
                  >
                    Info@globelinkplacement.com
                  </a>
                  . If we have sent you a promotional email, you may send us a
                  return email asking to be omitted from future email
                  distributions. This opt out does not apply to information
                  provided to the Company as a result of a product purchase,
                  warranty registration, product service experience or other
                  transactions.
                </li>
                <li>
                  <span className="font-medium text-[#75000e]">
                    Targeted Advertising.
                  </span>{" "}
                  If you do not want us to use information that we collect or
                  that you provide to us to deliver advertisements according to
                  our advertisers' target-audience preferences, you can opt-out
                  by sending us an email stating your request to{" "}
                  <a
                    href="mailto:Info@globelinkplacement.com"
                    className="text-blue-600 hover:underline"
                  >
                    Info@globelinkplacement.com
                  </a>
                  . For this opt-out to function, you must have your browser set
                  to accept all browser cookies.
                </li>
              </ul>
            </p>
            <p className="text-gray-700">
              We do not control third parties' collection or use of your
              information to serve interest-based advertising. However these
              third parties may provide you with ways to choose not to have your
              information collected or used in this way.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Accessing and Correcting Your Information
            </h2>
            <p className="text-gray-700 mb-4">
              You can review and change your personal information by logging
              into the Website and visiting your account profile page.
            </p>
            <p className="text-gray-700 mb-4">
              You may also send us an email at{" "}
              <a
                href="mailto:Info@globelinkplacement.com"
                className="text-blue-600 hover:underline"
              >
                Info@globelinkplacement.com
              </a>{" "}
              to request access to, correct or delete any personal information
              that you have provided to us. We cannot delete your personal
              information except by also deleting your user account. We may not
              accommodate a request to change information if we believe the
              change would violate any law or legal requirement or cause the
              information to be incorrect.
            </p>
            <p className="text-gray-700 mb-4">
              Please include your current contact information, the information
              you are interested in accessing and your requested changes. We
              will provide you access to the personal information requested,
              subject to reasonable limitations provided by law, unless it
              infringes on the privacy of other individuals. If we do not
              provide you with access, we will provide you with the reason for
              refusal and inform you of any exceptions relied upon.
            </p>
            <p className="text-gray-700">
              If you delete your User Contributions from the Website, copies of
              your User Contributions may remain viewable in cached and archived
              pages, or might have been copied or stored by other Website users.
              Proper access and use of information provided on the Website,
              including User Contributions, is governed by our terms of use{" "}
              <a
                href="http://www.globelinkplacement.com/terms"
                className="text-blue-600 hover:underline"
              >
                www.globelinkplacement.com/terms-of-use
              </a>
              .
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Governing Law & Jurisdiction
            </h2>
            <p className="text-gray-700">
              This Privacy Policy is governed by and operated in accordance with
              the laws of India. If any of the parties wish to seek legal
              recourse, they may do so by using the courts of law in Surat,
              Gujarat, India.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Data Security
            </h2>
            <p className="text-gray-700 mb-4">
              We have implemented measures designed to secure your personal
              information from accidental loss and from unauthorized access,
              use, alteration, and disclosure. All information you provide to us
              is stored on our secure servers behind firewalls. Any payment
              transactions will be encrypted.
            </p>
            <p className="text-gray-700 mb-4">
              The safety and security of your information also depends on you.
              Where we have given you (or where you have chosen) a password for
              access to certain parts of our Website, you are responsible for
              keeping this password confidential. We ask you not to share your
              password with anyone. We urge you to be careful about giving out
              information in public areas of the Website like message boards.
              The information you share in public areas may be viewed by any
              user of the Website.
            </p>
            <p className="text-gray-700">
              Unfortunately, the transmission of information via the internet is
              not completely secure. Although we do our best to protect your
              personal information, we cannot guarantee the security of your
              personal information transmitted to our Website. Any transmission
              of personal information is at your own risk. We are not
              responsible for circumvention of any privacy settings or security
              measures contained on the Website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Changes to Our Privacy Policy
            </h2>
            <p className="text-gray-700">
              It is our policy to post any changes we make to our privacy policy
              on this page with a notice that the privacy policy has been
              updated on the Website home page. If we make material changes to
              how we treat our users' personal information, we will notify you
              by email to the primary email address specified in your account
              and/or through a notice on the Website home page. The date the
              privacy policy was last revised is identified at the top of the
              page. You are responsible for ensuring we have an up-to-date
              active and deliverable email address for you, and for periodically
              visiting our Website and this privacy policy to check for any
              changes.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              Contact Information
            </h2>
            <p className="text-gray-700">
              To ask questions or comment about this privacy policy and our
              privacy practices, contact us at:
              <br />
              Swastik Universal, Office No. A-306, Near valentine Cinema,
              Piplod, Surat, Gujarat, 395007.
              <br />
              To register a complaint or concern, please send us an email at{" "}
              <a
                href="mailto:Info@globelinkplacement.com"
                className="text-blue-600 hover:underline"
              >
                Info@globelinkplacement.com
              </a>
              .
            </p>
          </section>

          <p className="text-gray-700 italic">
            We appreciate your trust in Globelink Techservices (OPC) Private
            Limited. Please read this Privacy Policy carefully before using our
            Website or providing any personal information.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
